define('enums',["i18n"], function (i18n) {
    return new function () {
        var me = this;
        
        me["OpeningStatus"] = {
            values: {1: "Open", 2: "TemporaryClosed", 3: "Closed", 4: "Nonstop", 5: "OnRequest", 6: "PickupOrDelivery", 100: "Unknown"},
            names: {
                "cs": {
                    0: "", 1: i18n.t("Frontend.Otevreno"), 2: i18n.t("Frontend.DocasneUzavreno"), 3: i18n.t("Frontend.Uzavreno"), 4: i18n.t("Frontend.Nonstop"), 5: i18n.t("Frontend.PoDomluve"), 6: i18n.t("Frontend.VydejARozvoz"), 100: i18n.t("Frontend.NeniZnamo")
                }
            }
        };
        
        me["DayOfWeek"] = {
            values: {0: "Sunday", 1: "Monday", 2: "Tuesday", 3: "Wednesday", 4: "Thursday", 5: "Friday", 6: "Saturday"},
            names: {
                "cs": {
                    0: i18n.t("Frontend.SundayShort"), 1: i18n.t("Frontend.MondayShort"), 2: i18n.t("Frontend.TuesdayShort"), 3: i18n.t("Frontend.WednesdayShort"), 4: i18n.t("Frontend.ThursdayShort"), 5: i18n.t("Frontend.FridayShort"), 6: i18n.t("Frontend.SaturdayShort")
                }
            }            
        };

        me["VenueChangeStatus"] = {
            values: {0: "Waiting", 1: "Accepted", 2: "Rejected"},
            colors: {0: "orange", 1: "green", 2: "red"},
            names: {
                "cs": {
                    0: i18n.t("Frontend.CekaNaSchvaleni"), 1: i18n.t("Frontend.Schvaleno"), 2: i18n.t("Frontend.Zamitnuto")
                }
            }
        };
        
        
        me.valueName = function (enumType, value, language) {
            var en = me[enumType];
            
            if(!en)
                return value;
            
            return en.names[language || "cs"][value] || value;
        };
        
        me.valueColor = function (enumType, value) {
            var en = me[enumType];

            if(!en)
                return "";
            
            return en.colors[value] || "";
        }
    };
});

